import { render, staticRenderFns } from "./previewTraining.vue?vue&type=template&id=0b4292b6&scoped=true&"
import script from "./previewTraining.vue?vue&type=script&lang=js&"
export * from "./previewTraining.vue?vue&type=script&lang=js&"
import style0 from "./previewTraining.vue?vue&type=style&index=0&id=0b4292b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4292b6",
  null
  
)

export default component.exports